import React from "react";
import GoogleLogin from 'react-google-login';

import "../Auth/auth.css";


const USER_NAME_VALID = "https://ops-adduser.builtwithdark.com/isavailable/"

class CreateAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gmailOauth: null,
      invalidUserName: null,
      invalidName: null,
      invalidEmail: null,
      internalComments: [],
      userdata: {
        name: "",
        email: "",
        username: "",
        customGreeting: "",
        internalComments: ""
      },
      submittedForm: false,
      formResponse: null
    };
  }

  componentDidMount() {
    this.fetchInternalComments()
  }


  fetchInternalComments = () =>{
    fetch("https://ops-adduser.builtwithdark.com/getInternalComments", {
      method: 'GET',
      dataType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(response => response.json())
    .then(response => {
        this.setState({
          internalComments: response
        })
    })
  }

  responseGoogle = (e) => {
    let gmailOauth = false
    if(e && e.profileObj && e.profileObj.email.includes("darklang.com")){
      gmailOauth = {...e.tokenObj, email: e.profileObj.email}
      fetch('https://ops-adduser.builtwithdark.com/set-gmail', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: e.profileObj.email,
          access_token: e.tokenObj.access_token,
          expires_in: e.tokenObj.expires_in
        })
        })
    }
    this.setState({
      gmailOauth: gmailOauth
    })
  }

  renderOauth = () =>{
    switch (this.state.gmailOauth) {
      case null:
        return <div className="google-oauth"><GoogleLogin
        clientId="53517193723-pbavkhqi7gf9k5bk8iun16far32ekolb.apps.googleusercontent.com"
        scope="https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/gmail.send"
        buttonText="Login"
        onSuccess={this.responseGoogle}
        onFailure={this.responseGoogle}
        cookiePolicy={'single_host_origin'}
      /></div>
      case false:
        return <div>
           <h1 className="medium-title light-purple">Only Dark Employees can create accounts at the moment</h1>
         </div>
      default: 
        return this.renderCreateAcc()
    }
  }

  verifyUsername = () =>{
    let {username} = this.state.userdata
    if(this.state.userdata.username.length >= 3 && username === username.toLowerCase()){
      fetch(USER_NAME_VALID + this.state.userdata.username, {
        method: 'GET',
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      }).then(response => response.json())
      .then(response => {
          this.setState({
            invalidUserName: response? null : "The username entered is unavailable"
          })
      })
    }else{
      this.setState({
        invalidUserName: "Must be at least 3 characters and lowercase"
      })
    } 
  }

  validatefield = (type, val) =>{
    let invalid = false
    if (val.length < 1){
      invalid = true
    }
    switch (type) {
      case "name" :
        this.setState({
          invalidName: invalid? "Required field" : null
        })
        break;
      default:
        this.setState({
          invalidEmail: invalid? "Required field" : null
        })
        break;
    }
    
  }
  
  validateForm = () =>{
    let {userdata, gmailOauth, invalidUserName, invalidEmail, invalidName} = this.state
    this.verifyUsername(userdata.username)

    if(!invalidName && !invalidEmail && !invalidUserName){
        let userDataToSend = {
          name: userdata.name,
          email: userdata.email,
          flavor: userdata.customGreeting,
          comment: userdata.internalComments,
          username: userdata.username,
          sender: gmailOauth.email
        }
        this.setState({
          submittedForm: true
        })
        fetch('https://ops-adduser.builtwithdark.com/user', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userDataToSend)
      }).then(response => response.json())
      .then(response => {
          this.setState({
            formResponse: JSON.stringify(response)
          })
      })
    }
  }

  renderCreateAcc = () =>{
    return <div>
      <div className="error-box" id="error-text"></div>
      <form>
        <div className="create-form-field">
          <p>Name:</p>
          {this.state.invalidName && <p className="error">{this.state.invalidName}</p>}
          <input type="text" placeholder="name" id="name" name="name" 
          onBlur={()=>{this.validatefield("name", this.state.userdata.name)}}
          value={this.state.userdata.name}
          onChange={(e)=>{this.setState({userdata: {...this.state.userdata, name: e.target.value || ""}})}}
          />
        </div>

        <div className="create-form-field">
          <p>Email:</p>
          {this.state.invalidEmail && <p className="error">{this.state.invalidEmail}</p>}
          <input type="text" placeholder="email" id="email" name="email"
          onBlur={()=>{this.validatefield("email", this.state.userdata.email)}}
          value={this.state.userdata.email}
          onChange={(e)=>{this.setState({userdata: {...this.state.userdata, email: e.target.value || ""}})}} />
        </div>

        <div className="create-form-field">
          <p>Username:</p>
          {this.state.invalidUserName && <p className="error">{this.state.invalidUserName}</p>}
          <input type="text" placeholder="username" id="username" name="username" value={this.state.userdata.username}
          onChange={(e)=>{this.setState({userdata: {...this.state.userdata, username: e.target.value || ""}})}}onBlur={this.verifyUsername}/>
        </div>

        <div className="create-form-field">
          <p>Custom Greeting:</p>
          <input type="text" placeholder="custom greeting" id="customGreeting" name="customGreeting" value={this.state.userdata.customGreeting}
          onChange={(e)=>{this.setState({userdata: {...this.state.userdata, customGreeting: e.target.value || ""}})}}/>
        </div>

        <div className="create-form-field">
          <p>Internal Comment:</p>
          <div className="select-wrapper">
          <select onFocus={()=>{this.fetchInternalComments()}} value={this.state.userdata.internalComments} onChange={(e)=>{this.setState({userdata: {...this.state.userdata, internalComments: e.target.value || ""}})}}>
            <option value="" disabled selected>Select an Internal comment</option>
            {this.state.internalComments.map((val)=>
              <option selected={this.state.userdata.internalComments} key={val} value={val}>{val}</option>
            )}
          </select>
          </div>
        </div>
        
        <button type="button" onClick={()=>this.validateForm()}>Create Account</button>
      </form>
    </div>;
  }

  createAnother = () =>{
    this.setState({
      invalidUserName: null,
      invalidName: null,
      invalidEmail: null,
      userdata: {
        name: "",
        email: "",
        username: "",
        customGreeting: "",
        internalComments: ""
      },
      submittedForm: false,
      formResponse: null
    })
  }

  renderResponse = () =>{
    return <div className="response">
      {this.state.formResponse}
      <div>
        <button type="button" onClick={()=>this.createAnother()}>Create another Account</button>
      </div>
    </div>
  }

  render() {
    return(
      <div className="auth-container">
        <p className="large-title center-text">{this.state.submittedForm && !this.state.formResponse? "Creating user....": this.state.formResponse? "User info" : "Create Dark account"}</p>
        {this.state.gmailOauth == null && <p className="medium-title center-text light-purple">For now this is for dark employees only</p>}
        {this.state.submittedForm && !this.state.formResponse? <div>LOADING</div>: this.state.formResponse? this.renderResponse(): this.renderOauth()}
      </div>
    )
  }
}

export default CreateAccount;
